import React from 'react';
import PropTypes from 'prop-types';

class OAuthDialog extends React.Component {
	constructor(props) {
		super(props);
		this.setPopupInterval = this.setPopupInterval.bind(this);
		this.clearPopupInterval = this.clearPopupInterval.bind(this);
	}

	componentWillUnmount() {
		this.clearPopupInterval();
	}

	setPopupInterval(cb, timeout) {
		this.clearPopupInterval();
		this.popupCloseInterval = setInterval(cb, timeout);
	}

	clearPopupInterval() {
		this.popupCloseInterval && clearInterval(this.popupCloseInterval);
		this.popupCloseInterval = undefined;
	}

	getPopupFeatures(width, height) {
		const winLeft = Math.max((window.screenLeft ? window.screenLeft : window.screenX) || 0, 0);
		const winTop = Math.max((window.screenTop ? window.screenTop : window.screenY) || 0, 0);
		const left = Math.max((winLeft + (window.innerWidth / 2) - (width / 2)), 0);
		const top = Math.max((winTop + (window.innerHeight / 2) - (height / 2)), 0);
		return `chrome=yes,width=${width},height=${height},top=${top},left=${left}`;
	}

	render() {
		const { onClose, popupHeight, popupWidth, credential } = this.props;
		const popup = window.open(
			credential.formatted_authentication_url,
			credential.name,
			this.getPopupFeatures(popupWidth, popupHeight)
		);
		if (popup) {
			// wait for it to close
			this.setPopupInterval(() => {
				if (popup.closed) {
					this.clearPopupInterval();
					onClose && onClose();
				}
			}, 200);
		}
		return null;
	}
}

OAuthDialog.propTypes = {
	/**
	 * The credential to perform OAuth for.
	 */
	credential: PropTypes.shape({
		name: PropTypes.string.isRequired,
		formatted_authentication_url: PropTypes.string.isRequired
	}).isRequired,

	/**
	 * Callback when the popup is closed.
	 */
	onClose: PropTypes.func.isRequired,

	/**
	 * The preferred height of the popup.
	 */
	popupHeight: PropTypes.number,

	/**
	 * The preferred width of the popup.
	 */
	popupWidth: PropTypes.number
};

OAuthDialog.defaultProps = {
	popupHeight: 600,
	popupWidth: 480
};

export default OAuthDialog;
